// import { Component, OnInit } from "@angular/core";
// import { BaseComponent } from "../pages/base.component";
// import { ToastrService } from "ngx-toastr";
// import { CommonService } from "src/app/services/common.service";
// import { FileuploadService } from "src/app/services/fileupload.service";
// import { ActivatedRoute, Router } from "@angular/router";

// @Component({
//   selector: "app-cde-dashboard",
//   templateUrl: "./cde-dashboard.component.html",
//   styleUrls: ["./cde-dashboard.component.css"],
// })
// export class CdeDashboardComponent extends BaseComponent implements OnInit {
//   dashboardDetails: any = "";
//   barChartData: any = [];
//   barChartLabels: any[] = [];
//   countyName: any = "";

//   public barChartType: any = "bar";
//   public barChartOptions: any = {
//     responsive: true,
//     scales: {
//       xAxes: [
//         {
//           gridLines: { display: false },
//           scaleLabel: { display: true, labelString: "Sub-County" },
//         },
//       ],
//       yAxes: [
//         {
//           gridLines: { display: true },
//           ticks: { beginAtZero: true },
//           scaleLabel: { display: true, labelString: "Number of Institutions" },
//         },
//       ],
//     },
//   };

//   constructor(
//     protected CommonService: CommonService,
//     protected toastr: ToastrService,
//     private route: Router,
//     private active: ActivatedRoute
//   ) {
//     super(CommonService, toastr);
//   }

//   ngOnInit(): void {
//     this.active.queryParams.subscribe((res: any) => {
//       if (res.cd == 'true'){
//       this.LoadDBDitails()
//       }  
//     })
//     this.LoadDBDitails();
//   }

//   async LoadDBDitails() {
//     this.dashboardDetails = [];
//     let roleId: any = 0;
//     const decryptedValue: any = await this.CommonService.decryptAesGcm(
//       localStorage.getItem("RoleId") || "0",
//       this.CommonService.secretKey
//     );
//     roleId = decryptedValue;
//     // this.CommonService.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//     //   roleId = value;
//     // });
//     const userData = JSON.parse(sessionStorage.getItem("userData") || "");
//     this.countyName = userData?.counties_name;
//     this.dashboardDetails = "";
//     let payLoad = {
//       v_tnt_code: localStorage.getItem("TenantCode"),
//       v_county_id: userData?.county_id,
//       v_sub_county_id: userData?.subcounty_id,
//       v_role_id: localStorage.getItem("RoleId"),
//       v_schoollevel: localStorage.getItem("schoolLevelID"),
//     };
//     this.CommonService.postCall(
//       `Dashboard/LoadCdeScdeAdminDashboard`,
//       payLoad
//     ).subscribe((res: any) => {
//       this.dashboardDetails = res;
//       const list =
//         this.dashboardDetails?.DISTRIBUTION_OF_INSTITUTIONS_BY_SUB_COUNTY || [];
//       // Labels: sub-county names (field named 'reject' in payload)
//       this.barChartLabels = list.map((x: any) => x?.reject ?? "");
//       // Datasets: Total and Pending series
//       this.barChartData = [
//         {
//           label: "Total",
//           data: list.map((x: any) => +x?.total || 0),
//           backgroundColor: "rgba(30, 136, 229, 0.6)",
//           borderColor: "#1e88e5",
//           hoverBackgroundColor: "rgba(30, 136, 229, 0.8)",
//           hoverBorderColor: "#1e88e5",
//         },
//       ];
//     });
//   }

//   getPercentage(
//     value: number,
//     total: number,
//     reject: number,
//     pending: number
//   ): string {
//     const numValue = value || 0;
//     const numTotal = total || 0;
//     const numReject = reject || 0;
//     const numPending = pending || 0;

//     const sum = numTotal + numReject + numPending;

//     if (sum === 0) {
//       return "0";
//     }

//     const percentage = (numValue / sum) * 100;
//     return percentage.toFixed(1);
//   }

//   getSegmentLength(segmentType: string): number {
//     const total = +this.dashboardDetails?.INSTITUTION_CATEGORIES?.total || 0;
//     const reject = +this.dashboardDetails?.INSTITUTION_CATEGORIES?.reject || 0;
//     const pending =
//       +this.dashboardDetails?.INSTITUTION_CATEGORIES?.pending || 0;

//     const sum = total + reject + pending;

//     if (sum === 0) {
//       return 0;
//     }

//     let value = 0;
//     switch (segmentType) {
//       case "total":
//         value = total;
//         break;
//       case "reject":
//         value = reject;
//         break;
//       case "pending":
//         value = pending;
//         break;
//     }

//     return (value / sum) * 502.4;
//   }
//   navigateToReview(statusId: any, subCountyId: any) {
//     // this.route.navigate(["/HOME/registration/schoolApproval/5094"]);
//     this.route.navigate(
//       ['/HOME/registration/schoolApproval/5094'],
//       { queryParams: { status: statusId, subCountyId: subCountyId } }
//     );
//   }

//   goToSchoolApproval() {
//     this.route.navigate(["/HOME/registration/appeal/5096"]);
//   }

//   navigationTLUrl() {
//     this.route.navigate([`/HOME/reports/learnersRegisteredCounty/5136`]);
//   }
// }


import { Component, OnInit, OnDestroy } from "@angular/core";
import { BaseComponent } from "../pages/base.component";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { FileuploadService } from "src/app/services/fileupload.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-cde-dashboard",
  templateUrl: "./cde-dashboard.component.html",
  styleUrls: ["./cde-dashboard.component.css"],
})
export class CdeDashboardComponent extends BaseComponent implements OnInit, OnDestroy {
  dashboardDetails: any = "";
  barChartData: any = [];
  barChartLabels: any[] = [];
  countyName: any = "";
  private querySubscription: Subscription = new Subscription();

  public barChartType: any = "bar";
  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: { display: false },
          scaleLabel: { display: true, labelString: "Sub-County" },
        },
      ],
      yAxes: [
        {
          gridLines: { display: true },
          ticks: { beginAtZero: true },
          scaleLabel: { display: true, labelString: "Number of Institutions" },
        },
      ],
    },
  };

  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private route: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);
  }

  ngOnInit(): void {
    // Subscribe to query params changes
    this.querySubscription = this.active.queryParams.subscribe((res: any) => {
      // Reload data when cd=true or when school level changes (reload flag)
      if (res.cd == 'true' || res.reload === 'true') {
        this.LoadDBDitails();
      } else {
        this.LoadDBDitails();
      }
    });

    // Initial load
    this.LoadDBDitails();
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
  }

  async LoadDBDitails() {
    this.dashboardDetails = [];
    let roleId: any = 0;
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId") || "0",
      this.CommonService.secretKey
    );
    roleId = decryptedValue;
    
    const userData = JSON.parse(sessionStorage.getItem("userData") || "");
    this.countyName = userData?.counties_name;
    this.dashboardDetails = "";
    
    // Get the current school level - this will now reflect the updated value
    const currentSchoolLevel = localStorage.getItem("schoolLevelID") || "";
    
    let payLoad = {
      v_tnt_code: localStorage.getItem("TenantCode"),
      v_county_id: userData?.county_id,
      v_sub_county_id: userData?.subcounty_id,
      v_role_id: localStorage.getItem("RoleId"),
      v_schoollevel: currentSchoolLevel,
    };
    
    this.CommonService.postCall(
      `Dashboard/LoadCdeScdeAdminDashboard`,
      payLoad
    ).subscribe((res: any) => {
      this.dashboardDetails = res;
      const list =
        this.dashboardDetails?.DISTRIBUTION_OF_INSTITUTIONS_BY_SUB_COUNTY || [];
      // Labels: sub-county names (field named 'reject' in payload)
      this.barChartLabels = list.map((x: any) => x?.reject ?? "");
      // Datasets: Total and Pending series
      this.barChartData = [
        {
          label: "Total",
          data: list.map((x: any) => +x?.total || 0),
          backgroundColor: "rgba(30, 136, 229, 0.6)",
          borderColor: "#1e88e5",
          hoverBackgroundColor: "rgba(30, 136, 229, 0.8)",
          hoverBorderColor: "#1e88e5",
        },
      ];
    });
  }

  getPercentage(
    value: number,
    total: number,
    reject: number,
    pending: number
  ): string {
    const numValue = value || 0;
    const numTotal = total || 0;
    const numReject = reject || 0;
    const numPending = pending || 0;

    const sum = numTotal + numReject + numPending;

    if (sum === 0) {
      return "0";
    }

    const percentage = (numValue / sum) * 100;
    return percentage.toFixed(1);
  }

  getSegmentLength(segmentType: string): number {
    const total = +this.dashboardDetails?.INSTITUTION_CATEGORIES?.total || 0;
    const reject = +this.dashboardDetails?.INSTITUTION_CATEGORIES?.reject || 0;
    const pending =
      +this.dashboardDetails?.INSTITUTION_CATEGORIES?.pending || 0;

    const sum = total + reject + pending;

    if (sum === 0) {
      return 0;
    }

    let value = 0;
    switch (segmentType) {
      case "total":
        value = total;
        break;
      case "reject":
        value = reject;
        break;
      case "pending":
        value = pending;
        break;
    }

    return (value / sum) * 502.4;
  }
  
  navigateToReview(statusId: any, subCountyId: any) {
    this.route.navigate(
      ['/HOME/registration/schoolApproval/5094'],
      { queryParams: { status: statusId, subCountyId: subCountyId } }
    );
  }

  goToSchoolApproval() {
    this.route.navigate(["/HOME/registration/appeal/5096"]);
  }

  navigationTLUrl() {
    this.route.navigate([`/HOME/reports/learnersRegisteredCounty/5136`]);
  }
}